const loadSVGImage = (svgel) => {
    // get the markup synchronously
    const markup = new XMLSerializer().serializeToString(svgel);
    const img = new Image();
    return new Promise((res, rej) => {
        img.onload = () => res(img);
        img.onerror = rej;
        // convert to a dataURI
        img.src = 'data:image/svg+xml,' + encodeURIComponent(markup);
    });
};

const getSVGDOM = (src: string) => {
    return fetch(src)
        .then((resp) => resp.text())
        .then((text) => new DOMParser().parseFromString(text, 'image/svg+xml'));
};

export const recolorImageFromUrl = async (params: {
    src: string;
    canvasWidth: number;
    canvasHeight: number;
    color: string;
}) => {
    const { src, canvasHeight, canvasWidth, color } = params;
    const svgDoc = await getSVGDOM(src);
    // There is no standard to draw relative sizes in canvas
    svgDoc.documentElement.setAttribute('width', canvasWidth.toString());
    svgDoc.documentElement.setAttribute('height', canvasHeight.toString());
    // generate the first <img> from current DOM state
    // here do your DOM manips
    svgDoc.querySelectorAll('path').forEach((el) => {
        el.setAttribute('fill', color);
        // el.setAttribute('stroke', color);
        // el.setAttribute('stroke-width', '0');
    });
    // generate new <img>
    const coloredImage = loadSVGImage(svgDoc);

    return Promise.resolve(coloredImage);
};
